import { DataLayer } from "@allwyn/utils/data-layer";

export namespace MainMenuAnalytics {
    export const pushButtonClick = (codename: string, placement: "menu" | "footer") => {
        DataLayer.push({
            event: "action.click.button",
            action: {
                click: {
                    name: codename,
                    eventProperty2: placement,
                },
            },
        });
    };

    export const initializeMainMenuClickTracking = (menuElement: HTMLElement): void => {
        menuElement.addEventListener("click", (event) => {
            if (!(event.target instanceof Element)) return;

            const link = event.target.closest<HTMLElement>(
                ".main-menu-link, .main-menu-accordion__nav-list-link, .main-menu__link-expand-button"
            );
            if (!link || !menuElement.contains(link)) return;

            const labelElement = link.matches(".main-menu__link-expand-button")
                ? link.closest(".main-menu-link__wrapper")?.querySelector(".main-menu-link__text")
                : link.querySelector(".main-menu-link__text, .main-menu-accordion__nav-list-text");
            const label = labelElement?.textContent?.trim();
            if (!label) return;

            const nestedMenu = link.closest(".main-menu-nav-list--nested");
            const categoryElement = nestedMenu
                ? nestedMenu.closest(".main-menu-nav-list__item")?.querySelector(".main-menu-link__text")
                : link.matches(".main-menu-accordion__nav-list-link")
                ? link
                      .closest(".main-menu-accordion__item")
                      ?.querySelector(".main-menu-accordion__button .main-menu-link__text")
                : null;
            const category = categoryElement?.textContent?.trim();

            DataLayer.pushInstant({
                event: "action.click.menu",
                action: {
                    click: {
                        label,
                        eventProperty1: category ? "sub-menu" : "main-menu",
                        ...(category ? { eventProperty2: category } : {}),
                    },
                },
            });
        });
    };

    // DL3.63
    export const pushNavigationClick = (label: string) => {
        DataLayer.pushInstant({
            event: "action.click.navigation",
            action: {
                click: {
                    label,
                    eventProperty1: "smain",
                },
            },
        });
    };

    export const pushMenuOpened = () => {
        DataLayer.push({
            event: "action.open.menu",
        });
    };
}
